/* import __COLOCATED_TEMPLATE__ from './scope.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { computed } from '@ember/object';

// Scopes that are implicitly granted by broader parent scopes
const IMPLIED_SCOPES = {
  read_tags: ['read_users_companies', 'write_users_companies'],
  write_tags: ['write_users_companies'],
};

export default Component.extend({
  hasPermission: computed('appPackageScopes.[]', 'scope.id', function () {
    let scopeIds = this.appPackageScopes || [];
    let scopeId = this.get('scope.id');
    if (scopeIds.includes(scopeId)) {
      return true;
    }
    let impliedBy = IMPLIED_SCOPES[scopeId];
    return impliedBy ? impliedBy.some((s) => scopeIds.includes(s)) : false;
  }),

  isImpliedPermission: computed('appPackageScopes.[]', 'scope.id', function () {
    let scopeIds = this.appPackageScopes || [];
    let scopeId = this.get('scope.id');
    if (scopeIds.includes(scopeId)) {
      return false;
    }
    let impliedBy = IMPLIED_SCOPES[scopeId];
    return impliedBy ? impliedBy.some((s) => scopeIds.includes(s)) : false;
  }),

  impliedByName: computed('appPackageScopes.[]', 'scope.id', 'allScopes.[]', function () {
    let scopeIds = this.appPackageScopes || [];
    let scopeId = this.get('scope.id');
    let impliedBy = IMPLIED_SCOPES[scopeId];
    if (impliedBy) {
      let grantingScopeId = impliedBy.find((s) => scopeIds.includes(s));
      if (grantingScopeId) {
        let allScopes = this.allScopes || [];
        let grantingScope = allScopes.find((s) => s.id === grantingScopeId);
        return grantingScope ? grantingScope.name : grantingScopeId;
      }
    }
    return null;
  }),
});
